import { Button, Flex, TextControl } from "@wordpress/components";
import { useState } from "react";
import Tables from "../tables";
import { TimesIcon } from "@wptb/ui/icons/actions";
import { createNewTable } from "@wptb/external/utils";

interface PickerProps {
  setTable: (id: string, isNew?: boolean) => void;
  id?: string;
}

const TableCreator = ({ setTable }: PickerProps) => {
  const [rows, setRows] = useState<number>(4);
  const [cols, setCols] = useState<number>(4);

  const onCreateNew = () => {
    if (cols < 1 || rows < 1) {
      return;
    }
    const id = createNewTable(rows, cols);
    setTable(id, true);
  };
  return (
    <Flex gap="10px" justify="center" align="end">
      <TextControl
        __nextHasNoMarginBottom
        type="number"
        label={"Column count"}
        value={cols}
        onChange={(count) => setCols(Number(count))}
        min="1"
        className="blocks-table__placeholder-input"
      />
      <TextControl
        __nextHasNoMarginBottom
        type="number"
        label={"Row count"}
        value={rows}
        onChange={(count) => setRows(Number(count))}
        min="1"
        className="blocks-table__placeholder-input"
      />
      <Button
        className="blocks-table__placeholder-button"
        variant="primary"
        onClick={onCreateNew}
        type="button"
      >
        Create
      </Button>
    </Flex>
  );
};

const PickerPage = ({ id, setTable }: PickerProps) => {
  const [activeTab, setActiveTab] = useState<string>("tables");
  const [search, setSearch] = useState<string>("");

  const onSelect = (id: number) => {
    setTable(id.toString());
  };
  return (
    <div className="wptb-mini-picker">
      <div className="wptb-mini-picker-top">
        <h2>WP Table Builder</h2>
        <div className="wptb-mini-picker-search">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 48 48"
          >
            <g
              fill="none"
              stroke="currentColor"
              strokeLinejoin="round"
              strokeWidth="4"
            >
              <path d="M21 38c9.389 0 17-7.611 17-17S30.389 4 21 4S4 11.611 4 21s7.611 17 17 17Z" />
              <path
                strokeLinecap="round"
                d="M26.657 14.343A7.98 7.98 0 0 0 21 12a7.98 7.98 0 0 0-5.657 2.343m17.879 18.879l8.485 8.485"
              />
            </g>
          </svg>
          <input
            type="search"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="wptb-mini-picker-tabs">
          <button
            type="button"
            className={activeTab === "tables" ? "active" : ""}
            onClick={() => setActiveTab("tables")}
          >
            Tables
          </button>
          <button
            type="button"
            className={activeTab === "create" ? "active" : ""}
            onClick={() => setActiveTab("create")}
          >
            Create
          </button>
          {id && (
            <button type="button" onClick={() => setTable(id)}>
              {TimesIcon}
            </button>
          )}
        </div>
      </div>
      <div className="wptb-mini-picker-content">
        {activeTab === "tables" ? (
          <Tables onSelect={onSelect} search={search} />
        ) : (
          <TableCreator setTable={setTable} />
        )}
      </div>
    </div>
  );
};
export default PickerPage;
